import React, { useMemo, useState } from 'react';
import styles from './Sidebar.module.scss';

import Tree from '../Tree/Tree';
import { useLocation } from 'react-router-dom';
import { useSidebarStore } from '../../store/useSidebar';

const Sidebar = () => {
  const [ lastLocation, setLastLocation ] = useState('');

  const collapsed = useSidebarStore(state => state.collapsed)
  const setCollapsed = useSidebarStore(state => state.setCollapsed)
  const menu = useSidebarStore(state => state.menu)
  let location = useLocation() as any;

  if(lastLocation !== location.pathname){
    setCollapsed(false)

    setLastLocation(location.pathname)
  }

  const uiVersion = process.env.REACT_APP_UI_VERSION || "unknown";

  return (
    <aside 
      className={styles.aside}
      style={collapsed ? {width:'60%', padding: '1rem 0'}: {width:'0', padding:'0'}}
      >
      {collapsed && (
        <>
          <Tree data={menu} className={styles.customMenu}/>
        </>
      )}
      <div className="d-tree-node border-0" style={{cursor: 'pointer', padding: '0 0 0 1rem'}}>
        <div style={{fontSize: '1rem', textDecoration: 'none', color: 'white'}}>
          <>
            Versão {uiVersion}
          </>
        </div>
      </div>
    </aside>
  )
};

export default Sidebar;
